<template>
    <div class="d-flex flex-column">
        <v-select v-model="status" variant="outlined" density="compact" :items="statuses" :label="$t('status')" />
    </div>
</template>

<script lang="ts">
    import {Component, Prop, VModel, Vue} from 'vue-facing-decorator'

    @Component
    export class ModifyManualStatus extends Vue {
        @VModel() status
        @Prop({default: () => [], type: Array}) statusList

        get statuses() {
            const statuses = this.statusList || [
                'CONFIRMED',
                'CANCELLED',
                'REJECTED',
                'CONFIRMATION PENDING',
                'QUOTE',
                'PRE-BOOKING',
            ]
            return statuses.map(value => ({value, title: this.$t(`bookingStatus.${value.split(' ').join('_')}`)}))
        }
    }

    export default ModifyManualStatus
</script>
